import React from "react";
import styles from "./TermsConditions.module.scss";

const TermsConditions = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropogation();
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.contentDiv}>
        <h3>Qreativs Terms & Conditions</h3>
        <p>
          Welcome to Qreativs! By using our platform, you agree to these Terms &
          Conditions. Please read them carefully.
        </p>

        <ol>
          <li>
            <span>Acceptance of Terms</span>
            <p>
              By creating an account or using Qreativs, you agree to comply with
              these Terms & Conditions and our Community Guidelines. If you do
              not agree, please do not use our services.
            </p>
          </li>
          <li>
            <span>Eligibility</span>
            <p>
              You must be at least 13 years old (or the minimum age required in
              your country) to use Qreativs. By using our platform, you
              represent that you meet this requirement.
            </p>
          </li>
          <li>
            <span>Your Content</span>
            <p>
              You retain ownership of the content you create and share on
              Qreativs. However, by posting content, you grant Qreativs a
              non-exclusive, worldwide, royalty-free license to display and
              promote your work within the platform and in connection with
              Qreativs' services. You are responsible for ensuring that your
              content does not infringe on others' intellectual property rights.
            </p>
          </li>
          <li>
            <span>Prohibited Conduct</span>
            <ul style={{ listStyleType: "disc" }}>
              <li>Violation of our community guidelines.</li>
              <li>Post content that is illegal, harmful, or offensive.</li>
              <li>Harass, spam, or impersonate others.</li>
              <li>Misuse reporting or moderation tools.</li>
              <li>Attempt to access unauthorized areas of Qreativs.</li>
            </ul>
          </li>
          <li>
            <span>Account Suspension & Termination</span>
            <p>
              We reserve the right to suspend or terminate your account if you
              violate these Terms, our Community Guidelines, or applicable laws.
              Where possible, we’ll notify you and provide an opportunity to
              appeal.
            </p>
          </li>
          <li>
            <span>Intellectual Property</span>{" "}
            <p>
              All Qreativs branding, design, and platform features are the
              property of Qreativs and protected under copyright and trademark
              laws. You may not use our trademarks without permission.
            </p>
          </li>
          <li>
            <span>Disclaimer of Warranties</span>
            <p>
              Qreativs is provided “as is” and we make no warranties regarding
              the platform’s performance or availability. Use it at your own
              risk.
            </p>
          </li>
          <li>
            <span>Limitation of Liability</span>
            <p>
              To the fullest extent permitted by law, Qreativs is not liable for
              any indirect or consequential damages arising from your use of the
              platform.
            </p>
          </li>

          <li>
            <span>Changes to Terms</span>
            <p>
              We may update these Terms occasionally. We'll notify you of
              significant changes. Continued use of Qreativs means you accept
              the revised terms.
            </p>
          </li>
          <li>
            <span>Contact Us</span>
            <p>
              If you have questions about these Terms, reach out to us at
              support@qreativs.com
            </p>
          </li>
        </ol>
      </div>

      <hr />

      <div className={styles.contentDiv}>
        <h3>Qreativs Privacy Policy</h3>
        <p>
          At Qreativs, we respect your privacy and are committed to protecting
          your personal information. This Privacy Policy explains what data we
          collect, how we use it, and your rights.
        </p>
        <ol>
          <li>
            <span>Information We Collect</span>
            <p>
              When you use Qreativs, we collect the following types of
              information:
            </p>
            <ol type="a">
              <li>
                <p>Information You Provide:</p>
                <ul>
                  <li>
                    Name, username, email address, and profile information.
                  </li>
                  <li>Creative work you upload or share.</li>
                  <li>Messages you send through the platform.</li>
                  <li>
                    Payment information (processed securely via third-party
                    providers).
                  </li>
                </ul>
              </li>
              <li>
                <p>Automatically Collected Information:</p>
                <ul>
                  <li>Usage data (e.g., pages viewed, projects browsed).</li>
                  <li>
                    Device information (browser type, IP address, operating
                    system).
                  </li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <span>How We Use Your Information</span>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve the Qreativs platform.</li>
              <li>Match creators with projects.</li>
              <li>
                Communicate with you about your account, activities, and
                updates.
              </li>
              <li>Personalize your experience.</li>
              <li>Ensure the safety and security of our community.</li>
              <li>Comply with legal obligations.</li>
            </ul>
          </li>
          <li>
            <span>Sharing Your Information</span>
            <p>
              We do not sell your personal information. We may share your data
              with:
            </p>
            <ul>
              <li>Other users, when you publish public content.</li>
              <li>
                Service providers (e.g., payment processors, cloud hosting).
              </li>
              <li>Law enforcement or legal bodies when required by law.</li>
            </ul>
          </li>
          <li>
            <span>How We Protect Your Information</span>
            <p>
              We use industry-standard security practices (encryption, secure
              servers, access controls) to protect your data. However, no system
              is 100% secure.
            </p>
          </li>
          <li>
            <span>Your Rights</span>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you.</li>
              <li>Correct or delete your personal data..</li>
              <li>Object to or restrict certain uses of your data..</li>
              <li>Export your data in a portable format..</li>
            </ul>
          </li>
          <li>
            <span>Data Retention</span>
            <p>
              We retain your information while your account is active and as
              needed to comply with legal, tax, or operational requirements.
            </p>
          </li>
          <li>
            <span>Changes to This Policy</span>
            <p>
              We may update this Privacy Policy from time to time. We’ll notify
              you of significant changes. Your continued use of Qreativs means
              you accept the updated policy.
            </p>
          </li>
          <li>
            <span>Contact Us</span>
            <p>
              If you have any questions or concerns about this Privacy Policy,
              please reach out to us at Qreativs.
            </p>
          </li>
          <li>
            <span>Data Retention</span>
            <p>
              We retain your information while your account is active and as
              needed to comply with legal, tax, or operational requirements.
            </p>
          </li>
        </ol>
      </div>

      {/* <div className={styles.buttonSection}>
      <button type="submit" onClick={(e)=>handleSubmit(e)} >Agree&Continue</button>
      </div> */}
    </div>
  );
};

export default TermsConditions;
